import fetchServer from "../fetchServer";


export default async function downlaodPDF(data) {
  var result = {return: 0,msg: 'Error',data: {}}

//   let token = store.getState().user.userData.accessToken;
  
  await fetchServer({method: "POST",url: `https://production-pdf-service-510880133590.europe-west1.run.app/api/v1/generate-pdf`,data,
    //   headers: {Authorization: `Bearer ${token}`},
      api: '',
  })
  .then((res) => {
    // console.log(" => ",{...res})
    if(res) {
      if(res.status === 200) {
        result = {return: 1,msg: "Successfull",data: res.data?.data};
      }
    } 
  })
  .catch((err) => {
    console.log("Network Error: ",err);
    
    // result = {return: 1,msg: 'Successfull',data:[]}
  })

  return result;
}